export const labels = {
	proceed: {
		label: "Label.MobileCreator.AlternativeProducts.Continue",
		default: "Continue",
	},

	back: {
		label: "Label.MobileCreator.AlternativeProducts.Back",
		default: "Back",
	},

	designNotAvailableTitle: {
		label: "Label.MobileCreator.AlternativeProducts.DesignNotAvailableTitle",
		default: "This design is not available on your selected product",
	},

	designNotAvailableDescription: {
		label: "Label.MobileCreator.AlternativeProducts.DesignNotAvailableDescription",
		default:
			"You will fallback on a design for this product but might lose some changes." +
			" Do you want to continue? You can always undo this by clicking the undo button in the creator.",
	},

	attributeName: (attributeTypeCode?: string) => {
		if (!attributeTypeCode) return undefined;
		return {
			label: `Label.Mobilecreator.AttributesChoice.${attributeTypeCode}`,
			default: "attributes",
		};
	},

	// {0}: Alternative product title
	// {1}: AttributeName
	// {2}: Value(s) for the attributename
	productAttributeNotAvailable: {
		label: "Label.MobileCreator.AlternativeProductsAttributes.NotAvailable",
		default: "{0} {1} {2} is not available.",
	},
} as const;
